import { useQuery } from '@tanstack/react-query';

import { offerApi } from '../apis/offerApis';

interface MobileOptionsResponse {
  itunes: Array<{ name: string; storeId: string }>;
  google: Array<{ name: string; storeId: string }>;
}

export function useMobileOptions() {
  const { data, isLoading, error } = useQuery<MobileOptionsResponse>({
    queryKey: ['mobileOptions'],
    queryFn: async () => {
      return await offerApi.getMobileOfferOptions();
    },
  });

  const itunesOptions = data?.itunes
    ? data.itunes.map(item => ({
        label: item.name,
        value: item.storeId,
      }))
    : [];

  const googleOptions = data?.google
    ? data.google.map(item => ({
        label: item.name,
        value: item.storeId,
      }))
    : [];

  return {
    itunesOptions,
    googleOptions,
    isLoading,
    error,
  };
}
